// extracted by mini-css-extract-plugin
export default {"editor":"style_editor__sRX1d","loading":"style_loading__p26gM"};